/**
 * DE TVÅ LÄGENA: 'hem' (Mitt jobb) och 'lag' (Laget).
 *
 * LÄGET ÄR INTE ETT EGET TILLSTÅND. Det är en FUNKTION av vilken skärm man
 * står på (`Skarm.lage` i app/skarmar.ts), precis som i prototypen, där
 * lägesknapparna bara är `go('hem')` och `go('lag')`. Ett separat lägestillstånd
 * vid sidan av adressen kan glida isär från den — och då visar växeln "Laget"
 * medan skärmen är Mitt jobb.
 *
 * VÄXLINGEN ÄR OBEFINTLIG FÖR EN MONTÖR, INTE GÖMD.
 * Fyra spärrar, och de är oberoende av varandra:
 *
 *   1. TYPEN. `useLage()` lämnar en DISKRIMINERAD UNION. När kanSeLaget är
 *      false är `vaxla` av typen `null` — inte en funktion som inte gör något.
 *      Ett `styrning.vaxla('lag')` går då helt enkelt inte att kompilera, och
 *      en agent som försöker får veta det av tsc och inte av en användare.
 *
 *   2. KOMPONENTEN. <Lagesvaxel> renderar null när växling inte finns. Det
 *      står ingen inaktiverad knapp kvar att fundera på.
 *
 *   3. ROUTERN. `synligaSkarmar(false)` innehåller inte lagets skärmar alls,
 *      så /attestera matchar ingenting och adressen får startsidan. Ingen
 *      403-sida, ingen "du saknar behörighet" — skärmen finns inte i hans
 *      karta.
 *
 *   4. SERVERN. Det är den som faktiskt håller regeln: TODAY och
 *      INVOICE_BASIS är FULL_VIEW_ROLES, och SYNC_RULES avgör varje skrivning
 *      mot rollen UR D1. De tre punkterna ovan är gränssnitt, inte säkerhet.
 *      Den som tar bort dem får en ful app, inte en osäker.
 *
 * GRÄNSEN GÅR VID VYN, INTE VID ROLLEN. kanSeLaget är ROLE_VIEW[roll] ===
 * 'full', vilket är manager OCH bookkeeper. Bokföraren SKA se laget — han står
 * i FULL_VIEW_ROLES och rutterna bakom lagets skärmar är öppna för honom — men
 * han får inte GÖRA något där (beslut 07: han förekommer inte i en enda rad i
 * SYNC_RULES). Knapparna styrs därför av `arChef`, se app/session.tsx.
 */

import { STARTSKARM } from './skarmar';
import type { Lage } from './skarmar';
import { useNavigering } from './navigering';
import { useSession } from './session';

export type Lagesstyrning =
  | { readonly kanSeLaget: false; readonly lage: 'hem'; readonly vaxla: null }
  | { readonly kanSeLaget: true; readonly lage: Lage; readonly vaxla: (till: Lage) => void };

export const useLage = (): Lagesstyrning => {
  const { session } = useSession();
  const { plats, ga } = useNavigering();
  const kanSeLaget = session.status === 'inloggad' && session.kanSeLaget;

  if (!kanSeLaget) {
    // Skärmen kan inte vara en lägesskärm: routern släpper inte in dem.
    return { kanSeLaget: false, lage: 'hem', vaxla: null };
  }
  return {
    kanSeLaget: true,
    lage: plats.skarm.lage,
    vaxla: (till) => ga(STARTSKARM[till]),
  };
};
